module.exports = __webpack_public_path__ + "img/360.d0c80b30.svg";